<coin-v2-dialog-frame [header]="'general.info' | translate">
  <div class="body-container">
    <p class="msg">{{ 'deputy.add-deputy-msg' | translate }}</p>
    <div class="timeframe">
      <mat-form-field
        class="admin-form-field-outline admin-form-field-outline--shadow"
        appearance="outline"
        floatLabel="always"
        (click)="pickerStart.open()">
        <input
          matInput
          placeholder="Start (optional)"
          [matDatepicker]="pickerStart"
          [(ngModel)]="startsAt" />
        <mat-icon matSuffix>date_range</mat-icon>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        class="admin-form-field-outline admin-form-field-outline--shadow"
        appearance="outline"
        floatLabel="always"
        (click)="pickerEnd.open()">
        <input
          matInput
          placeholder="End (optional)"
          [matDatepicker]="pickerEnd"
          [(ngModel)]="endsAt" />
        <mat-icon matSuffix>date_range</mat-icon>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      [type]="'outline'"
      [icon]="'chevron_right'"
      [iconPos]="'right'"
      [text]="'general.btnCancel' | translate"
      (click)="cancel()"></coin-v2-button>
    <coin-v2-button
      [type]="'primary'"
      [icon]="'chevron_right'"
      [iconPos]="'right'"
      [text]="'general.btnConfirm' | translate"
      (click)="confirm()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
